import {Component, Input} from '@angular/core';

/**
 * A component that renders an SVG icon for "Calendar Clear"
 *
 * @member {string} tooltip ? The tooltip that needs to be displayed on this icon.
 */
@Component({
    selector: 'app-icon-calendar-clear',
    templateUrl: './icon-calendar-clear.component.html',
    styleUrls: ['./icon-calendar-clear.component.scss'],
    standalone: false
})
export class IconCalendarClearComponent  {

  /**
   * Assign a tooltip that needs to be displayed on this icon as soon as the user hovers on it.
   *
   * @param tooltip ? The tooltip that needs to be displayed on this icon.
   */
  @Input() tooltip?: string;
}
